import { StepsProps } from ".";
import {
  Chargepoint,
  Company,
  End,
  Finance,
  Installer,
  Owner,
  Site,
  Start,
  Team,
  Tiers,
} from "../../molecules/steps";

export const Steps: Record<number, React.FC<StepsProps>> = {
  0: () => <Start />,
  1: ({ form, nextStep }) => (
    <Tiers setValue={form.setValue} nextStep={nextStep} />
  ),
  2: ({ form }) => (
    <Chargepoint
      setValue={form.setValue}
      reset={form.reset}
      getValues={form.getValues}
    />
  ),
  3: ({ form }) => (
    <Company
      setValue={form.setValue}
      // getValues={form.getValues}
      control={form.control}
    />
  ),
  4: ({ form }) => <Team control={form.control} />,
  5: ({ form }) => <Owner control={form.control} />,
  6: ({ form }) => <Finance control={form.control} />,
  7: ({ form }) => <Installer control={form.control} />,
  8: ({ form }) => <Site setValue={form.setValue} control={form.control} />,
  9: ({ state, teamUrl }) => <End state={state} teamUrl={teamUrl} />,
};
